import { Alert, AlertLevel, AnchorButton } from '@cluey/cluey-components';
import classNames from 'classnames';

export interface Props {
  alertType: AlertLevel;
  title: string;
  body?: string;
  color: '' | 'bg-yellow-1' | 'bg-blue-1';
  href: string;
}

const PolicyAlert = ({ alertType, title, body, color, href }: Props) => {
  return (
    <div className={classNames('flex flex-col gap-x-3.5 rounded-xl lg:flex-row', color)} role="alert">
      <Alert
        body={null}
        className={classNames('mb-0 grow lg:pr-0', !!body ? 'items-start' : 'items-center')}
        title={title}
        type={alertType}
      >
        {!!body && <p className="mt-2.5">{body}</p>}
      </Alert>
      <div className="basis-auto py-5 pl-6 pr-6 text-left lg:basis-60 lg:pl-0 lg:text-right">
        <AnchorButton className="self-start" href={href} size="xs" appearance="reverse" target="blank">
          View my plan
        </AnchorButton>
      </div>
    </div>
  );
};

export default PolicyAlert;
